import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const ReportDetailForm = lazy(
  () => import('@components/Report/ReportDetailForm')
);

/** 기업보고자료 관리 > 상세 */
const ReportDetail = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense>
          <ReportDetailForm />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default ReportDetail;
